import React from 'react';
import { VirtualTableHeadCell } from "../../virtualized-table/types";
import { SelectColumnFilter } from '../../virtualized-table/components/filter';
import DownloadFile from '../software/download-file';

export const softwareHeadCells: VirtualTableHeadCell[] = [
  {
    accessor: 'id',
    Header: 'SHA',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'fileName',
    Header: 'File Name',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'partNumber',
    Header: 'Part Number',
    Filter: SelectColumnFilter,
    filter: 'textAndCheckbox',
  },
  {
    accessor: 'createdTime',
    Header: 'Upload Date #',
  },
  {
    accessor: 'createdBy',
    Header: 'User ID',
  },
  {
    accessor: 'downloadIcon',
    Header: 'Download',
    component: DownloadFile,
  },
];

export const softwareSortableAccessors = {
  fileName: false,
};
